export default __webpack_public_path__ + "static/media/shutDown.f2839b46.png";